var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.75H7v-1.5h14v1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.944 11.116 11.53 4.53l-1.06-1.06-6.586 6.585a2.75 2.75 0 0 0 0 3.89l6.586 6.585 1.06-1.06-6.586-6.586a1.25 1.25 0 0 1 0-1.768Z",
    fill: "currentColor"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAxMi43NUw3IDEyLjc1VjExLjI1TDIxIDExLjI1VjEyLjc1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC45NDQ0OSAxMS4xMTYyTDExLjUzMDMgNC41MzAzOUwxMC40Njk2IDMuNDY5NzNMMy44ODM4MyAxMC4wNTU1QzIuODA5ODggMTEuMTI5NSAyLjgwOTg5IDEyLjg3MDcgMy44ODM4MyAxMy45NDQ2TDEwLjQ2OTYgMjAuNTMwNEwxMS41MzAzIDE5LjQ2OTdMNC45NDQ0OSAxMi44ODM5QzQuNDU2MzMgMTIuMzk1OCA0LjQ1NjMzIDExLjYwNDMgNC45NDQ0OSAxMS4xMTYyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";